export const launchIntercomMessenger = (e?: React.ChangeEvent<any>) => {
    if (e) {
        e.preventDefault();
    }

    const viewingChatPreview =
        window.location.pathname.includes('/inbox/settings/test-chatbot') ||
        window.location.pathname.includes('/inbox/settings/chat-onboarding');

    if (
        // @ts-expect-error
        typeof window.Intercom !== 'undefined' &&
        Analytics.intercomWasInitialized &&
        !viewingChatPreview
    ) {
        // @ts-expect-error
        window.Intercom('show');
    } else {
        // Fallback URL for when Intercom does not load
        // Note: We intentionally do not load Intercom when logged in as support
        window.open('https://support.nutshell.com', '_blank');
    }
};
